import type { TypographyProps } from '@components/atoms/typography/types';
import { getPaletteColor } from '@components/atoms/typography/utils';
import styled from 'styled-components';

export const TypographyWrapper = styled.span<{
    $variant: TypographyProps['variant'];
    $color: TypographyProps['color'];
}>`
    ${(props) => {
        switch (props.$variant) {
            case 'text':
                return props.theme.typography.text;
            case 'text-medium':
                return props.theme.typography.textMedium;
            case 'text-regular':
                return props.theme.typography.textRegular;
            case 'text-bold':
                return props.theme.typography.textBold;
            case 'small-text':
                return props.theme.typography.smallText;
            case 'small-text-bold':
                return props.theme.typography.smallTextBold;
            case 'big-text-semibold':
                return props.theme.typography.bigTextSemiBold;
            case 'big-text-bold':
                return props.theme.typography.bigTextBold;
            case 'big-text-regular':
                return props.theme.typography.bigTextRegular;
            case 'button':
                return props.theme.typography.button;
            case 'h1':
                return props.theme.typography.h1;
            case 'h2':
                return props.theme.typography.h2;
            case 'h3':
                return props.theme.typography.h3;
            default:
                return props.theme.typography.text;
        }
    }};
    color: ${(props) => getPaletteColor(props.$color, props.theme)};
`;
